/* eslint-disable */
import React from 'react'
import Sliders from './Sliders';

const HeroHome = () => {
    return (
        <>
            <div className="height-70vh home-hero">
                <div className="container-fluid height-100">
                    <div className="row height-100">
                        <div className="col-12 height-100 padding-0 margin-0">
                            <Sliders />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeroHome
